// Короткий сигнал нового сообщения: две ноты через WebAudio (без аудиофайлов). Включается/выключается в центре уведомлений.
const KEY = 'miko-sound';
export const isSoundOn = () => { try { return localStorage.getItem(KEY) !== '0'; } catch { return true; } };
export const setSoundOn = (on) => { try { localStorage.setItem(KEY, on ? '1' : '0'); } catch { /* приватный режим */ } };

let ctx = null;
export function playPing() {
  if (!isSoundOn()) return;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = ctx || new AC();
    if (ctx.state === 'suspended') ctx.resume();     // до первого действия пользователя браузер может не дать играть: тогда тихо пропускаем
    const t0 = ctx.currentTime;
    [[880, 0], [1175, 0.11]].forEach(([freq, at]) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = 'sine'; o.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, t0 + at); g.gain.exponentialRampToValueAtTime(0.12, t0 + at + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, t0 + at + 0.22);
      o.connect(g); g.connect(ctx.destination); o.start(t0 + at); o.stop(t0 + at + 0.25);
    });
  } catch { /* звук не критичен */ }
}
